export default "__VITE_ASSET__CAPTTPir__"